import { render, staticRenderFns } from "./AddStockLayer.vue?vue&type=template&id=f17a68d0&scoped=true&"
import script from "./AddStockLayer.vue?vue&type=script&lang=js&"
export * from "./AddStockLayer.vue?vue&type=script&lang=js&"
import style0 from "./AddStockLayer.vue?vue&type=style&index=0&id=f17a68d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17a68d0",
  null
  
)

export default component.exports